import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import mixins from '@/mixins/global.js';
import Layout from '@/layouts/layout.vue';
import Simple from '@/layouts/simple.vue';
import Guest from '@/layouts/guest.vue';
import App from './App.vue';
import 'mutationobserver-shim';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import vuetify from './plugins/vuetify';
import VueProgressBar from 'vue-progressbar';
// import { subscribeUser } from '@/utils/sw';
Vue.component('layout', Layout);
Vue.component('guest', Guest);
Vue.component('simple', Simple);

Vue.config.productionTip = false;

// global mixins
Vue.mixin(mixins);

Vue.use(VueProgressBar, {
	color: '#6A31FF',
	failedColor: 'red',
	thickness: '6px',
});

// Solo en produccion nos subscribimos al sw
// desactivado sw 25/04/2022
// if (process.env.NODE_ENV === 'production') subscribeUser();

export default new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount('#app');
